import { render } from "./MovieModal.vue?vue&type=template&id=4592b710&scoped=true"
import script from "./MovieModal.vue?vue&type=script&lang=js"
export * from "./MovieModal.vue?vue&type=script&lang=js"

import "./MovieModal.vue?vue&type=style&index=0&id=4592b710&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4592b710"

export default script